import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Spinner } from 'react-bootstrap'
import {toastr} from 'react-redux-toastr'

import { cronometro } from '../services/functions'
import { 
    onSubmitStatus 
} from '../actions/AgentesActions';

class BoxAgents extends Component {
    constructor(props) {
        super(props);

        this.state = { conta: 0, agents: [], intevalID: 0, ck_hangup: [], btnAction: 0, checkedItems: {} };

        this.handleSubmitStatus = this.handleSubmitStatus.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    async handleSubmitStatus(event) {
        event.preventDefault();

        let agents = this.state.ck_hangup;
        if(!agents.length) {
            toastr.warning('Ops!', 'Por favor selecione pelo menos um agente !');
            return false;
        }
    
        // btAction = 1 Quando esta removendo das pausas
        if(this.state.btnAction===1) {

            var r = window.confirm("Voce tem certeza que deseja remover as pausa desses agente(s)");
            if (r == true) {

                for (let index = 0; index < agents.length; index++) {
                    const c_agent_id = parseInt(agents[index]);
                    let result = await this.props.onSubmitStatus({ c_agent_id, value: 1, label: 'OPERANDO' });
                    if(result) {
                        // delete agents[index];
                    }
                }

                toastr.success('Sucesso!', 'Todos os agentes foram removidos da pausa !');
            }

            this.setState({ ck_hangup: [], checkedItems: {} });
            return true;
        } 

        var r = window.confirm("Voce tem certeza que deseja deslogar esses agente(s)");
        if (r == true) {
            for (let index = 0; index < agents.length; index++) {
                const c_agent_id = parseInt(agents[index]);
                let result = await this.props.onSubmitStatus({ c_agent_id, value: 2, label: 'ENCERRADO SUPERVIDOR' });
                if(result) {
                    delete agents[index];
                }
            }
            this.setState({ ck_hangup: [], checkedItems: {}  })
        }
        
        return true
    }

    updateAgents = (props) => {
        const agenteFilter = _.filter(props.agents, val => { 
            return _.find(val.queues, (value, key) => 
                props.queuesListener.indexOf(parseInt(key)) >=0
            );
        });

        // console.log('nao',agenteFilter)
    
        const agentsOrderby = _.orderBy(agenteFilter, ['expired', 'status.c_pauses_id', 'timer'], ['desc', 'desc', 'desc'])
        this.setState({ agents: agentsOrderby })
    }
 
    componentWillReceiveProps(nextProps) {
        this.updateAgents(nextProps);
    }

    componentDidMount() {
        let intevalID = setInterval(this.passouSegundo, 300);
        this.setState({ intevalID });
    }

    passouSegundo = () => {

        let newAgents = this.state.agents.map( agente => {
            let time = 0;
            let timeCurrent = new Date().getTime();
            if(agente.status.iat){
                time = cronometro(agente.status.iat, timeCurrent);
            }

            let expired = 0;
            if(agente.status.exp > agente.status.iat && timeCurrent > agente.status.exp) {
                expired = 1;
            }

            let awnseringTime = 0;
            if(agente.awnsering){
                awnseringTime = cronometro(agente.awnsering.timestamp, timeCurrent);
                return { ...agente, timer: time, expired, c_pauses_id: agente.status.c_pauses_id, awnsering: {...agente.awnsering, timer: awnseringTime }}
            }

            return { ...agente, timer: time, expired, c_pauses_id: agente.status.c_pauses_id }
        })

   
        const agentsOrderby = _.orderBy(newAgents, ['expired','c_pauses_id', 'timer'], ['desc', 'desc' , 'desc'])
  
        this.setState({ agents: agentsOrderby })
    }

    componentWillUnmount() {
        clearInterval(this.state.intevalID);
    }


    async handleCheckboxChange(event) {
        const target = event.target;
        const { checked, name, value } = target;
        let newValue = []
        if(checked) {
            newValue = [...this.state.ck_hangup, value]
        } else {
            newValue = this.state.ck_hangup.filter(e => e !== value)
        }


        await this.setState({
            ck_hangup: newValue, 
            checkedItems: {
                ...this.state.checkedItems,
                [value]: checked
            }
        });

    }


    render() { 
        return (
            
            <div className="box box-warning" style={{ minHeight: '302px' } }>
                <form onSubmit={this.handleSubmitStatus}>
                    <div className="box-header with-border">
                        <h3 className="box-title">Agentes</h3>

                        <div className="box-tools pull-right">
                            
                            <button type="submit"  className="btn btn-default btn-sm" onClick={ () => { this.setState({ btnAction: 1 }) }}>
                                Remover pausa
                            </button>
                            &nbsp;
                            <button type="submit"  className="btn btn-default btn-sm" onClick={ () => { this.setState({ btnAction: 0 }) }}>
                                Deslogar
                            </button>
                        </div>
                    </div>
                    
                    <div className="box-body table-responsive no-padding">
                        
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nome</th>
                                        <th>Filas</th>
                                        <th>Status</th>
                                        <th>Ligação</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.agents.map( agent => {
                                        
                                        let label = 'label label-success';
                                        if(agent.status.c_pauses_id > 2) {
                                            label = 'label label-warning';
                                        }
                                        if(agent.status.exp > agent.status.iat && new Date().getTime() > agent.status.exp ) {
                                            label = 'label label-danger';
                                        }

                                        let inCall = '';
                                        let linkedid = ''
                                        if(agent.awnsering) {
                                            linkedid = agent.awnsering?.linkedid?.replace(/_/gi, ".");
                                            inCall =  
                                            <>
                                                <Spinner animation="grow" variant="success" size="sm"/>
                                                {agent.awnsering?.numbername} | {agent.awnsering?.timer}
                                            </>
                                        }

                                        let labelName = agent.status.name; 
                                        let checkBox =  (
                                                <input 
                                                    name={`agente[${agent.c_agent_id}]`}
                                                    type="checkbox"
                                                    value={agent.c_agent_id}
                                                    onChange={this.handleCheckboxChange}
                                                    checked={this.state.checkedItems[agent.c_agent_id] || false}
                                                    />
                                            );
                                        
                                        if(agent.conectado=="3") {
                                            labelName = 'Desconectando...';
                                            checkBox = '';
                                        }

                                        
                                        
                                        return (
                                            <tr key={agent.c_agent_id} >
                                                <td>
                                                    {checkBox}
                                                </td>
                                                <td>{agent.name} {agent.extension && `( ${agent.extension?.number} ) `}</td>
                                                <td>{Object.keys(agent.queues).join(", ")}</td>
                                                <td title={agent.timer && `TEMPO: ${agent.timer}`}>
                                                    <span className={label}>{labelName}</span>{' '} 
                                                </td>
                                                <td title={agent.awnsering && `Fila: ${agent.awnsering?.queue} Num: ${agent.awnsering?.number} | Linkedid: ${linkedid}`} >
                                                    {inCall}
                                                </td>
                                            </tr>
                                        )
                                    } )}
                                </tbody>
                            </table>
                    </div>
                </form>
            </div>
            
        );
    }
}

const mapStateToProps = state => {
    const agents = _.map(state.AgentesReducer.agents, (val, c_agent_id) => {

        if(val){
            let time = 0;

            if(val.status?.iat) {
                time = cronometro(val.status.iat, new Date().getTime())
                let expired = 0;
                if(val.status.exp > val.status.iat && new Date().getTime() > val.status.exp) {
                    expired = 1;
                }
        
                return {...val, c_agent_id, timer: time, expired};
            }

        }
        return {...val}
    });

    return ({
        agents,
    })
}
  
export default connect(mapStateToProps, { onSubmitStatus })(BoxAgents);